/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EodMelcoModelsCustomWarning
 */
export interface EodMelcoModelsCustomWarning {
    /**
     * 
     * @type {string}
     * @memberof EodMelcoModelsCustomWarning
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoModelsCustomWarning
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoModelsCustomWarning
     */
    message?: string | null;
}

export function EodMelcoModelsCustomWarningFromJSON(json: any): EodMelcoModelsCustomWarning {
    return EodMelcoModelsCustomWarningFromJSONTyped(json, false);
}

export function EodMelcoModelsCustomWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): EodMelcoModelsCustomWarning {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function EodMelcoModelsCustomWarningToJSON(value?: EodMelcoModelsCustomWarning | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'source': value.source,
        'message': value.message,
    };
}


